// File: services/register.js
import axios from "axios";

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;
const X_API_KEY = process.env.REACT_APP_API_KEY;

const getAuthHeaders = () => ({
  "x-api-key": X_API_KEY,
});

// Register user
export const registerUser = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/register`, formData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error register user:", error.response?.data || error.message);
    throw error;
  }
};
